<div class="calendar-grp">
    <div class="calendar-wrapper">
        <mat-calendar #calendar [dateClass]="dateClass()" (selectedChange)="odabraniDatum($event)">
        </mat-calendar>
    </div>
</div>
